<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Neuer QR-Code">
      <qr-code-form
        :qr-code="qrCode"
        submit-label="QR-Code anlegen"
        :form-submitted="saveQrCode"
        mode="new"
      ></qr-code-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import QrCodeForm from "@/components/forms/QrCodeForm"
import QrCodesRepository from "@/repositories/qr_codes_repository.js"

export default {
  metaInfo: {
    title: "Neuer QR-Code"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    QrCodeForm
  },
  data() {
    return {
      qrCode: {
        label: "",
        target_type: null,
        target_id: null
      }
    }
  },
  methods: {
    async saveQrCode(qrCode) {
      await QrCodesRepository.create(qrCode)
      this.$router.push({ name: "QrCodesPage" })
    }
  }
}
</script>
